export class GetNotifications {
  public static readonly type = '[Notifications] GetNotifications';
}
